import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function ProductDevelopmentApiAndFormulations() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Pharmaceutical Product Development & Project Management', 'Product Development – API & Formulations']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Pharmaceutical Product Development & Project Management
        </h2>

        {/* Section Title */}
        <div className="flex items-center gap-2 mb-4">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Product Development – API & Formulations
          </h3>
        </div>

        <p className="text-sm text-[#05326D] mb-2 font-bold">
          End-to-End Solutions for Active & Inactive Ingredients, Formulations, and Global Regulatory Success

        </p>
        <p className="mb-4 text-sm text-[#05326D]">
          At FDAC Consultancy, we recognize that product development is the foundation of pharmaceutical innovation and commercial success. With decades of industry experience, we offer comprehensive project management services for formulations, APIs, and excipients, guiding clients from concept to commercialization across regulated markets worldwide.
        </p>
        <p className="mb-8 text-sm text-[#05326D]">
          Our strategic partnerships with state-of-the-art Contract Research Organizations (CROs) ensure that every development project is executed with precision, compliance, and speed—tailored to the requirements of US FDA, EU Health Authorities, MHRA, CDSCO, LATAM, GCC, South Africa, and other global jurisdictions.
        </p>

        <hr className="border-t border-gray-300 mb-8" />


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Core Development Services
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Patent Status Evaluation & Literature Search</p>
        <p className="ml-2 mt-2 text-[#05326D]">Non-Infringing Strategy Development</p>
        <p className="ml-2 mt-2 text-[#05326D]">Quality by Design (QbD)-Driven Formulation Development</p>
        <p className="ml-2 mt-2 text-[#05326D]">Prototype Formulation & Design of Experiments (DOE) Studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Risk Assessment & Potent Molecule Development</p>
        <p className="ml-2 mt-2 text-[#05326D]">Expertise in Dry Readymix Coating Formulations</p>
        <p className="ml-2 mt-2 text-[#05326D]">Development Support for NDA, ANDA, 505(b)(1), 505(b)(2)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Pre-Formulation & Reverse Engineering (Deformulation)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Lab to Pilot & Pivotal Batch Execution</p>
        <p className="ml-2 mt-2 text-[#05326D]">Process Validation & Optimization</p>
        <p className="ml-2 mt-2 text-[#05326D]">Lifecycle Extension & Brand Expansion Strategies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Solubilization & Bioavailability Enhancement</p>
        <p className="ml-2 mt-2 text-[#05326D]">Lyophilization & Packaging Development</p>
        <p className="ml-2 mt-2 text-[#05326D]">CTD-Compliant Documentation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Technology Transfer to CMO Sites</p>
        <p className="ml-2 mt-2 text-[#05326D]">Dossier Development for USA, EU, Australia, Turkey & RoW</p>


        {/* Dosage Form Expertise */}

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Dosage Form Expertise
          </span>
        </div>

        <p className="text-sm mb-3 text-[#05326D]">
          We support development across a wide range of dosage forms, ensuring regulatory alignment and market readiness:
        </p>

        <table className="w-full text-sm text-left text-gray-700 border mb-10">
          <thead className="bg-gray-100 text-[#05326D]">
            <tr>
              <th className="border px-4 py-2 text-[#05326D]">Dosage Form</th>
              <th className="border px-4 py-2 text-[#05326D]">Variants</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2 text-[#05326D]">Tablets</td>
              <td className="border px-4 py-2 text-[#05326D]">Immediate-release, Sustained-release, Delayed-release, Film-coated, Uncoated</td>
            </tr>
            <tr>
              <td className="border px-4 py-2 text-[#05326D]">Capsules</td>
              <td className="border px-4 py-2 text-[#05326D]">Powder-filled, Granule-filled</td>
            </tr>
            <tr>
              <td className="border px-4 py-2 text-[#05326D]">Pellets</td>
              <td className="border px-4 py-2 text-[#05326D]">Tablet or Capsule-filled</td>
            </tr>
            <tr>
              <td className="border px-4 py-2 text-[#05326D]">Powders</td>
              <td className="border px-4 py-2 text-[#05326D]">Bottled powder formulations</td>
            </tr>
            <tr>
              <td className="border px-4 py-2 text-[#05326D]">Liquids</td>
              <td className="border px-4 py-2 text-[#05326D]">Solutions, Suspensions, Emulsions</td>
            </tr>
            <tr>
              <td className="border px-4 py-2 text-[#05326D]">Semi-solids</td>
              <td className="border px-4 py-2 text-[#05326D]">Creams, Ointments</td>
            </tr>
            <tr>
              <td className="border px-4 py-2 text-[#05326D]">Parenterals</td>
              <td className="border px-4 py-2 text-[#05326D]">Injectables, Large Volume Parenterals (LVP)</td>
            </tr>
          </tbody>
        </table>

        {/* Infrastructure & Equipment */}

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Infrastructure & Equipment
          </span>
        </div>
        <p className="text-sm mb-4 text-[#05326D]">
          Our CRO partners are equipped with advanced machinery to support development at every scale—from bench and lab scale to kg-scale, pilot, and pivotal batches. Equipment includes:
        </p>

        <p className="ml-2 mt-2 text-[#05326D]">Compression Machines</p>
        <p className="ml-2 mt-2 text-[#05326D]">Sifters & Blenders</p>
        <p className="ml-2 mt-2 text-[#05326D]">Granulators</p>
        <p className="ml-2 mt-2 text-[#05326D]">Fluid Bed Processors (Granulation, Coating, Drying)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Coating Pans</p>
        <p className="ml-2 mt-2 text-[#05326D]">Capsule Filling Machines</p>
        <p className="ml-2 mt-2 text-[#05326D]">...and more, ensuring flexibility and scalability across all formulation types</p>


        {/* Why FDAC */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Why FDAC?
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Global regulatory alignment across major markets</p>
        <p className="ml-2 mt-2 text-[#05326D]">Strategic CRO selection based on product type and market entry goals</p>
        <p className="ml-2 mt-2 text-[#05326D]">Full-spectrum support from ideation to dossier submission</p>
        <p className="ml-2 mt-2 text-[#05326D]">Proven expertise in formulation science, regulatory documentation, and technology transfer</p>

      </div>
    </div>
  );
}

export default ProductDevelopmentApiAndFormulations;


